import script from "./BottomNavBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomNavBar.vue?vue&type=script&setup=true&lang=ts"

import "./BottomNavBar.vue?vue&type=style&index=0&id=ccef76ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccef76ec"]])

export default __exports__